export default __webpack_public_path__ + "static/media/inventory.f44e3281.svg";